declare global {
  // tslint:disable-next-line: interface-name
  interface Window {
    UserLeap: any
  }
}

export function userLeapInit(l, e, a, p?: any) {
  window.UserLeap = (...args: any[]) => {
    U._queue.push(args)
  }

  const U = window.UserLeap
  U.appId = a
  U._queue = []
  a = l.createElement('script')
  a.async = 1
  a.src = e + '?id=' + U.appId
  p = l.getElementsByTagName('script')[0]
  p.parentNode.insertBefore(a, p)
}

export default {
  userLeapInit
}



// WEBPACK FOOTER //
// ./src/services/userLeap.ts